export const START_IMPORT_APPOINTMENTS = 'START_IMPORT_APPOINTMENTS';
export const IMPORT_APPOINTMENTS = 'IMPORT_APPOINTMENTS';
export const CLEAR_APPOINTMENTS = 'CLEAR_APPOINTMENTS';
export const GET_APPOINTMENT = 'GET_APPOINTMENT';
export const IMPORT_BARBERS = 'IMPORT_BARBERS';
export const ADD_APPOINTMENT = 'ADD_APPOINTMENT';
export const UPDATE_APPOINTMENT = 'UPDATE_APPOINTMENT';
export const CANCEL_APPOINTMENT = 'CANCEL_APPOINTMENT';
export const APPOINTMENT_STATUS = {
  initial: 0,
  canceled: 1,
  arrived: 2,
};
export const APPOINTMENT_PAYMENT_STATUS = {
  scheduled: 'scheduled',
  authorized: 'authorized',
  paid: 'paid',
  partiallyPaid: 'partiallyPaid',
  failed: 'failed',
  refunded: 'refunded',
  partiallyRefunded: 'partiallyRefunded',
};
export const LOAD_APPOINTMENTS_PER_PAGE = 50;
export const FILTER_APPOINTMENTS = 'FILTER_APPOINTMENTS';
export const ADD_BARBER_FILTER = 'ADD_BARBER_FILTER';
export const REMOVE_BARBER_FILTER = 'REMOVE_BARBER_FILTER';
export const SHOW_ALL_BARBER_FILTERS = 'SHOW_ALL_BARBER_FILTERS';
export const HIDE_ALL_BARBER_FILTERS = 'HIDE_ALL_BARBER_FILTERS';
export const SET_STATUS_FILTER = 'SET_STATUS_FILTER';
export const SET_DATE = 'SET_DATE';
export const SET_START_OF_WEEK = 'SET_START_OF_WEEK';
export const LOAD_CUSTOMER_NOTES = 'LOAD_CUSTOMER_NOTES';
export const SET_CUSTOMER_NOTES = 'SET_CUSTOMER_NOTES';
export const RESET_CUSTOMER_NOTES = 'RESET_CUSTOMER_NOTES';
export const ADD_CASH_CHARGE = 'ADD_CASH_CHARGE';
export const CLOSE_APPOINTMENT_MODAL = 'CLOSE_APPOINTMENT_MODAL';
export const SET_PROMO_CODE = 'SET_PROMO_CODE';

export const RECURRING_FREQUENCIES = [
  { label: 'Weekly', value: 7 },
  { label: '2 Weeks', value: 14 },
  { label: '3 Weeks', value: 21 },
  { label: '4 Weeks', value: 28 },
  { label: '5 Weeks', value: 35 },
  { label: '6 Weeks', value: 42 },
  { label: '8 Weeks', value: 56 },
]
